import DropdownMenuHtml from "./IconWithDropdownMenuHtml.js";

export default class IconWithDropdownMenuCmp {
    #html = new DropdownMenuHtml();

    /**
     * @param {HTMLElement} parent
     * @param {string} iconText will be used in material icon span, for example "arrow_drop_down"
     */
    init(parent, iconText){
        this.#html.init(parent, iconText);
    }

    /**
     * @param {{
     *     id: string,
     *     name: string,
     *     title?: string,
     *     disabled?: boolean,
     *     hidden?: boolean
     * }[]} params
     */
    show(params){
        this.#html.show(params)
    }

    /**
     * @param {string} itemId
     * @param {function} cb
     */
    onItemClick(itemId, cb){
        this.#html.onItemClick(itemId, cb);
    }

    /**
     * @param {string} id
     * @param {string} name
     * @param {string} value
     */
    setMenuItemAttribute(id, name, value){
        this.#html.setMenuItemAttribute(id, name, value);
    }

    /**
     * @param {string} id
     * @param {string} name
     */
    removeMenuItemAttribute(id, name){
        this.#html.removeMenuItemAttribute(id, name);
    }
}